/**
 * @desc legend interface
 */
export var LegendType;
(function (LegendType) {
    LegendType["SERIES_LEGEND"] = "series";
    LegendType["DATUM_LEGEND"] = "datum";
    LegendType["GROUP_LEGEND"] = "group";
})(LegendType || (LegendType = {}));
